import styled from 'styled-components'

import colors from 'styles/colors'

interface CoordiantesType {
    x: number
    y: number
}

interface StoryTextProps {
    text: string
    coordinates: CoordiantesType
}

export const StoryText = ({ text, coordinates }: StoryTextProps) => {
    return (
        <StoryTextContainer
            style={{ left: `${coordinates.x}%`, top: `${coordinates.y}%` }}
        >
            <Text>{text}</Text>
        </StoryTextContainer>
    )
}

const StoryTextContainer = styled.div`
    border-radius: 2rem;
    background: ${colors.black157deg};
    display: inline-block;
    max-width: 90%;
    opacity: 0.7;
    padding: 1.7rem 2rem 2rem;
    position: absolute;
    z-index: 3;
    transform: translate(-50%, -50%);
`

const Text = styled.span`
    display: inline-block;
    background: transparent;
    border: 0px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #ffffff;
    opacity: 0.8;
    min-width: 2ch;
    font-weight: 600;
    font-size: 1.8rem;
`
